import { useEffect } from 'react';
import Swal from 'sweetalert2';

const ModalSweet = props => {
    const { title = 'Titulo', html = 'Texto', confirmButtonColor = 'red', icon = 'warnig', confirmButtonText = 'Fechar' } = props;
    const showAlert = () => {
        Swal.fire({
            title,
            html,
            confirmButtonColor,
            allowOutsideClick: false,
            icon,
            confirmButtonText,
            heightAuto: true
        });
    };

    useEffect(() => {
        if (props.exibiModal) {
            showAlert();
        }
    }, [props.exibiModal]);

    return null;
};

export default ModalSweet;
